import React, { useContext, useCallback } from 'react';

import { PolicyCheckbox as PolicyCheckboxComponent } from '../../../components/ui/Inputs/PolicyCheckbox';
import { useEvent } from '../../../utils/analytics/useEvent';
import { SignUpFormContext } from '../SignUpFormContext';

export function PolicyCheckbox() {
  const trackEvent = useEvent();
  const { bindPolicy, isLoading } = useContext(SignUpFormContext);

  const onRulesClick = useCallback(() => {
    trackEvent('identity – mlife registration - external link click', 'program rules', 'mliferegclicks');
  }, [trackEvent]);

  const onPolicyClick = useCallback(() => {
    trackEvent('identity – mlife registration - external link click', 'privacy policy', 'mliferegclicks');
  }, [trackEvent]);

  return (
    <PolicyCheckboxComponent
      onPolicyClick={onPolicyClick}
      onRulesClick={onRulesClick}
      disabled={isLoading}
      {...bindPolicy}
    />
  );
}

PolicyCheckbox.displayName = 'PolicyCheckboxField';
